import { Grid, Typography, Box, CardMedia, Divider, Chip, Stack } from "@mui/material";
import _ from "lodash";
import { getCartItemAddonBadges } from "utils/cart";
import { formatCurrencyNew } from "utils/helper";

const ProductList = ({ productList, currencySymbol }) => {
  return (
    <Grid item container xs={12}>
      {productList.map((product, i) => (
        <Grid item xs={12} key={i}>
          <Box sx={{ display: "flex", alignItems: "center", py: 2 }}>
            <Box sx={{ flexShrink: 0, mr: 2 }}>
              {_.get(product, "product_detail.images[0].image") ? (
                <CardMedia
                  component="img"
                  image={_.get(product, "product_detail.images[0].image", "")}
                  alt={_.get(product, "product_detail.product_name", "")}
                  sx={{
                    width: { xs: 90, sm: 110, md: 120 },
                    height: { xs: 90, sm: 110, md: 120 },
                    objectFit: "contain",
                    borderRadius: "10px",
                    display: "block",
                  }}
                />
              ) : (
                <Box
                  sx={{
                    width: { xs: 90, sm: 110, md: 120 },
                    height: { xs: 90, sm: 110, md: 120 },
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "rgba(0,0,0,0.05)",
                    border: "1px dashed rgba(0,0,0,0.2)",
                    borderRadius: "8px",
                  }}
                >
                  <Typography variant="body2" color="textSecondary">
                    No Image
                  </Typography>
                </Box>
              )}
            </Box>

            <Box sx={{ flex: 1 }}>
              <Typography sx={{ fontSize: "var(--fs-sm)", fontWeight: "600" }}>
                {_.get(product, "product_detail.product_name") ||
                  `Product ID: ${product.product_id || "N/A"}`}
              </Typography>
              <Typography
                sx={{ fontSize: "var(--fs-xs)", color: "var(--text-gray)", mt: 0.5 }}
              >
                Qty: {product.quantity}
              </Typography>
              {product?.product_detail?.size?.name &&
                product.product_detail.size.name !== "" &&
                product.product_detail.size.name !== "null" && (
                  <Typography sx={{ fontSize: "var(--fs-xs)", color: "var(--text-gray)" }}>
                    Size: {product.product_detail.size.name}
                  </Typography>
                )}
              {product?.product_detail?.color?.name &&
                product.product_detail.color.name !== "" &&
                product.product_detail.color.name !== "null" && (
                  <Typography sx={{ fontSize: "var(--fs-xs)", color: "var(--text-gray)" }}>
                    Color: {product.product_detail.color.name}
                  </Typography>
                )}
              {getCartItemAddonBadges(product).length > 0 && (
                <Box sx={{ mt: 0.5 }}>
                  <Typography sx={{ fontSize: "var(--fs-xs)", color: "var(--text-muted)", fontWeight: 600 }}>
                    Addons
                  </Typography>
                  <Stack direction="row" spacing={0.5} flexWrap="wrap" sx={{ mt: 0.3, gap: 0.5 }}>
                    {getCartItemAddonBadges(product).map((addon) => (
                      <Chip
                        key={addon.key}
                        size="small"
                        variant="outlined"
                        sx={{ fontSize: "var(--fs-xs)", borderRadius: "4px" }}
                        label={
                          <>
                            <span style={{ color: "var(--text-muted)" }}>
                              {addon.name} x{addon.quantity} :
                            </span>{" "}
                            <span style={{ color: "#111", fontWeight: 600 }}>
                              {formatCurrencyNew(addon.price, currencySymbol)}
                            </span>
                          </>
                        }
                      />
                    ))}
                  </Stack>
                </Box>
              )}
              <Typography sx={{ fontSize: "var(--fs-sm)", fontWeight: "700", mt: 1 }}>
                {currencySymbol} {_.get(product, "total_price", 0)}
              </Typography>
            </Box>
          </Box>
          <Divider />
        </Grid>
      ))}
    </Grid>
  );
};

export default ProductList;
